import WarningIcon from "../../assets/icons/WarningIcon";
import ExcelIcon from "../../assets/images/excel-icon.svg";
import { CustomModalProps } from "../../types";
import CustomModal from "../ui/CustomModal";
import Uploader from "./Uploader";

interface UploadExcelModalType extends CustomModalProps {
  warningText?: string | string[];
  handler: (data: FormData) => void;
  isLoading?: boolean;
  downloadLink?: string;
}

const accept = ".csv,.xls,.xlsx";

export default function UploadExcelModal({
  warningText,
  handler,
  isLoading,
  downloadLink,
  ...rest
}: UploadExcelModalType) {
  // const [filename, setFilename] = useState<string | null>(null);
  // const [fileList, setFileList] = useState<UploadFile[]>([]);

  // const handleUpload = (file: File) => {
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("name", file.name);

  //   setFilename(file.name);

  //   handler(formData);
  //   return;
  // };

  // const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
  //   setFileList(info.fileList);

  //   if (info.file.status === "removed") {
  //     setFilename("No file chosen");
  //   }
  // };

  return (
    <CustomModal className="upload-excel-modal" footer={false} {...rest}>
      <div className="h-[72px]">
        <img
          className="h-full object-contain"
          src={ExcelIcon}
          alt="Excel Icon"
        />
      </div>
      <Uploader
        handler={handler}
        accept={accept}
        downloadLink={downloadLink}
        isLoading={isLoading}
        label="Select a .csv/.xls/.xlsx file & click Import"
      />
      {/* <div className="my-6">
        <label className="text-body text-sm font-medium leading-normal">
          Select a .csv/.xls/.xlsx file & click Import
        </label>
        <Upload
          name="photo"
          beforeUpload={handleUpload}
          maxCount={1}
          accept={accept}
          showUploadList={false}
          onChange={handleChange}
          fileList={fileList}
          className="h-full block py-1.5"
          disabled={isLoading}
        >
          <Button
            className="flex items-center !justify-start !p-0 !border-display-light rounded-md"
            block
          >
            <span className="!flex justify-center items-center px-3 bg-[#5e718d] text-white h-full rounded-s-md">
              Browse file
            </span>
            <div className="px-2.5 gap-2 text-sm font-medium text-extra-gray overflow-hidden whitespace-nowrap text-ellipsis">
              {isLoading ? (
                "Uploading..."
              ) : (
                <span
                  className="overflow-hidden text-ellipsis"
                  style={{
                    direction: "unset",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {filename || "No file chosen"}
                </span>
              )}
            </div>
          </Button>
        </Upload>

        <div className="flex items-center gap-1.5">
          <span className="text-body-text text-sm leading-normal">
            Download Sample File
          </span>
          <Button
            className="download-button !p-0 !h-fit !border-none !shadow-none !font-semibold"
            size="small"
            icon={<DownloadIcon />}
            type="link"
            href={downloadLink}
            target="_blank"
            download
          >
            Download
          </Button>
        </div>
      </div> */}

      {warningText && (
        <div className="flex gap-1.5 p-4 bg-[#fff4f4] rounded-md items-center">
          <div className="text-dark-highlight">
            <WarningIcon />
          </div>
          <div className="flex-1 text-display-body text-sm leading-relaxed">
            {typeof warningText === "object" ? (
              <ul className="list-outside list-disc pl-5">
                {warningText.map((text, index) => (
                  <li key={index} className="mb-2.5 last:mb-0">
                    {text}
                  </li>
                ))}
              </ul>
            ) : (
              warningText
            )}
          </div>
        </div>
      )}
    </CustomModal>
  );
}
